import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    identifier: String
  }

  collapseAll() {
    const accordions = document.querySelectorAll(`[data-controller~="${this.identifierValue}"]`)

    accordions.forEach((el) => {
      const controller = this.application.getControllerForElementAndIdentifier(
        el, this.identifierValue
      );
      if (controller && controller.contentTarget &&
          !controller.contentTarget.classList.contains("collapsed")) {
        controller.collapse()
      }
    })
  }
}